// 模板消息管理
import { CQ } from "utils/commonQuest";
// import { dispatch } from "@rematch/core";
import {
  getNoticeList,
  getUserList,
  tagRead,
  tagCollect,
  unReadCount
} from "utils/interface";
// 消息枚举
import { ENoticeType } from "utils/enum/notice";
import { message } from "antd";
import { filterParams } from "utils/tool";

const commonMethod = async function(
  payload: any,
  rootState: any,
  request,
  _callback = args => {}
) {
  // 允许接口完成调用后，执行组件中的方法
  payload = payload || {};
  const callback = payload.callback || null;
  const param = { ...payload };
  // 删除参数对象中的callback对象，以便不传多余的参数
  delete param.callback;
  // 等待异步调用的结果
  const { data } = await CQ(request(param), true);
  if (_callback != null) {
    _callback(data);
  }
  callback && callback(data);
  // setTimeout(() => {

  // }, 1000);
  return data;
};

// 获取待修改的消息
const getUpdNotice = (state, data) => {
  if (data) {
    let noticeList: any = [];
    switch (data.type) {
      case ENoticeType.All:
        noticeList = state.all = [...state.all];
        break;
      case ENoticeType.Collect:
        noticeList = state.collect = [...state.collect];
        break;
      case ENoticeType.Unread:
        noticeList = state.unRead = [...state.unRead];
        break;
      default:
        noticeList = state.all = [...state.all];
        break;
    }

    const updNotices = noticeList.filter(item => {
      return data.ids.indexOf(item.id) != -1;
    });
    return updNotices;
  } else {
    return [];
  }
};

// 去除数组中的重复数据
function unique(list) {
  let arr: any = [],
    b = false;
  for (let i = 0; i < list.length; i++) {
    if (i == 0) arr.push(list[i]);
    b = false;
    if (arr.length > 0 && i > 0) {
      for (let j = 0; j < arr.length; j++) {
        if (arr[j].mid == list[i].mid) {
          b = true;
          //break;
        }
      }
      if (!b) {
        arr.push(list[i]);
      }
    }
  }
  return arr;
}

export const noticeMg = {
  name: "noticeMg",
  state: {
    isShowNotice: false,
    // 全部消息
    all: [],
    // 未读
    unRead: [],
    // 已收藏
    collect: [],
    // 客服列表
    userList: [],
    // sharedWorker 对象
    ws: null,
    // 消息面板当前选中的类型
    noticeCheckedType: null,
    // 消息面板ref对象
    noticePanelRef: null,
    // 未读消息统计
    unReadCount: null
  },
  reducers: {
    // 更新sharedWorker对象
    updateWS(state, data) {
      return {
        ...state,
        ws: data
      };
    },
    // 更新全部模板消息列表
    appendAll(state, data) {
      return {
        ...state,
        // 去除重复的数据
        all: unique([...state.all, ...data])
      };
    },
    // 添加消息 用于 服务端通过websocket推送的消息
    addNotice(state, data) {
      const noticeCType: any = state.noticeCheckedType,
        noticePanelRef: any = state.noticePanelRef;
      // 判断消息面板是否选中的是全部，如果是全部，接受推送消息时需要回到顶部
      if (noticeCType == ENoticeType.All) {
        //  noticePanelRef.returnToTop();
        noticePanelRef();
      }

      return {
        ...state,
        // 去除重复的数据
        all: unique([data, ...state.all])
      };
    },
    // 更新选中的类型
    updNoticeCType(state, data) {
      return {
        ...state,
        noticeCheckedType: data
      };
    },
    // 更新消息面板ref对象
    updNoticePanel(state, data) {
      return {
        ...state,
        noticePanelRef: data
      };
    },
    updateAll(state, data) {
      return {
        ...state,
        all: data
      };
    },
    // 更新未读模板消息列表
    updateUnRead(state, data) {
      return {
        ...state,
        unRead: data
      };
    },
    appendUnRead(state, data) {
      return {
        ...state,
        unRead: [...state.unRead, ...data]
      };
    },
    // 更新收藏模板消息列表
    updateCollect(state, data) {
      return {
        ...state,
        collect: data
      };
    },
    appendCollect(state, data) {
      return {
        ...state,
        collect: [...state.collect, ...data]
      };
    },
    // 更新客服列表
    updateUserList(state, data) {
      return {
        ...state,
        userList: data
      };
    },
    // 修改消息列表标记已读
    tagReadUpdNList(state, data) {
      let _state = { ...state };
      const upData = getUpdNotice(_state, data);
      if (upData.length > 0) {
        upData.map(item => {
          item.is_read = "1";
        });
      }

      // // 更新未读统计
      // dispatch["noticeMg"].getUnReadCount();

      message.config({ maxCount: 1 });
      message.success("操作成功");
      return _state;
    },
    // 标记全部已读
    tagAllReadUpdList(state, data) {
      if (state.unRead) {
        state.unRead = [];
      }

      message.config({ maxCount: 1 });
      message.success("操作成功");
      return {
        ...state,
        unReadCount: 0
      };
    },
    // 修改消息列表标记已收藏 | 取消收藏
    tagCollectUpdNList(state, data) {
      let _state = { ...state };
      const upData = getUpdNotice(_state, data.data);
      if (upData.length > 0) {
        upData.map(item => {
          item.is_collection = data.value;
        });
      }

      message.config({ maxCount: 1 });
      message.success("操作成功");
      return _state;
    },
    // 删除已收藏项
    removeCollect(state, data) {
      let _state = { ...state };
      try {
        const newData = state.collect.filter(item => {
          return item.id != data;
        });
        _state.collect = newData;
      } catch (error) {
        console.warn(error);
      }
      return _state;
    },
    // 更新 是否显示消息管理
    updateIsShowNotice(state, data) {
      return {
        ...state,
        isShowNotice: !state.isShowNotice
      };
    },
    // 更新未读消息总数
    updateUnReadCount(state, data) {
      return {
        ...state,
        unReadCount: data
      };
    },
    // 更新未读消息总数 带条件
    updateUnReadCountWithParams(state, data) {
      return {
        ...state,
        unReadCountWithParams: data
      };
    }
  },
  effects: {
    // 获取消息列表
    async getNoticeList(payload: any, rootState: any) {
      payload = payload || {};
      const callback = payload.callback;
      let param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      //debugger;
      if (Object.keys(param).length === 0) {
        param = {};
        param["type"] = "all";
        param["page"] = 1;
      } else {
        // 去除原始对象中为空的对象
        param = filterParams(param);
      }

      const data = await CQ(getNoticeList(param));
      console.log("payload.type", param.type);

      const update = (update, append) => {
        if (param["page"] == 1) {
          update(data);
        } else {
          append(data);
        }
      };

      switch (param.type) {
        case ENoticeType.All:
          update(this.updateAll, this.appendAll);
          break;
        case ENoticeType.Unread:
          update(this.updateUnRead, this.appendUnRead);
          break;
        case ENoticeType.Collect:
          update(this.updateCollect, this.appendCollect);
          break;
        default:
          this.updateAll(data);
          break;
      }

      callback && callback(data);
    },
    // 获取客服 | 客服群组
    async getUserList(payload: any, rootState: any) {
      const data = await CQ(getUserList());
      this.updateUserList(data);
    },
    // 标记已读
    async tagRead(payload: any, rootState: any) {
      const params = { id: payload.id };
      commonMethod(params, rootState, tagRead, data => {
        if (data && !data.error) {
          this.getUnReadCount();
          this.tagReadUpdNList({
            type: payload.type,
            ids: [payload.id]
          });
        }
      });
    },
    // 全部标记已读
    async tagAllRead(payload: any, rootState: any) {
      const params = { uid: payload.uid };
      commonMethod(params, rootState, tagRead, data => {
        if (data && !data.error) {
          this.tagAllReadUpdList();
        }
      });
    },
    // 标记收藏
    async tagCollect(payload: any, rootState: any) {
      const params = payload;
      commonMethod(params, rootState, tagCollect, data => {
        if (data && !data.error) {
          if (payload.type !== ENoticeType.Collect) {
            this.tagCollectUpdNList({
              data: {
                type: payload.type,
                ids: [payload.id]
              },
              value: params.cancel ? "0" : "1"
            });
          } else {
            this.removeCollect(payload.id);
          }
        }
      });
    },
    // 发布消息
    async sendNotice(payload: any, rootState: any) {
      const ws: any = rootState["noticeMg"].ws;
      ws.sendWSNotice("/index/ws/push", payload.data);
      if (payload.callback) {
        payload.callback(true);
      }
    },
    // 回到消息面板顶部
    async scrolToNoticePanelTop(payload: any, rootState: any) {
      const noticeMg = rootState["noticeMg"];
      const noticeCType: any = noticeMg.noticeCheckedType,
        noticePanelRef: any = noticeMg.noticePanelRef;
      if (noticeCType == ENoticeType.All) {
        //noticePanelRef.returnToTop();
        noticePanelRef();
      }
    },
    // 获取未读消息总数
    async getUnReadCount(payload: any, rootState: any) {
      const data = await commonMethod({}, rootState, unReadCount);
      this.updateUnReadCount(data);
    },
    // 获取未读消息总数 带条件
    async getUnReadCountWithParams(payload: any, rootState: any) {
      let param = payload;
      // 去除原始对象中为空的对象
      param = filterParams(param);
      const data = await commonMethod(param, rootState, unReadCount);
      this.updateUnReadCountWithParams(data);
    }
  }
};
